import * as React from 'react';
import { ThemeProvider as BaseThemeProvider, createGlobalStyle } from 'styled-components';

import { getColor, getShadow, theme } from '@process-advisor/process-miner/shared/theme';

const GlobalStyles = createGlobalStyle`
    @keyframes spinner-line-fade-more {
        0%, 100% {
            opacity: 0; /* minimum opacity */
        }
        1% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-fade-quick {
        0%, 39%, 100% {
            opacity: 0.25; /* minimum opacity */
        }
        40% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-fade-default {
        0%, 100% {
            opacity: 0.22; /* minimum opacity */
        }
        1% {
            opacity: 1;
        }
    }

    @keyframes spinner-line-shrink {
        0%, 25%, 100% {
            /* minimum scale and opacity */
            transform: scale(0.5);
            opacity: 0.25;
        }
        26% {
            transform: scale(1);
            opacity: 1;
        }
    }

    * {
        box-sizing: border-box;
        scrollbar-color: ${getColor('white')};
        scrollbar-width: thin;

        &::-webkit-scrollbar {
            width: 8px;
            height: 6px;
            margin-left: 5px;
            background-color: ${getColor('white')};
            border-radius: 6px;
        }

        &::-webkit-scrollbar-thumb {
            background-color: ${getColor('scrollBar')};
            border-radius: 6px;
        }
    }

    html {
        height: 100%;
    }

    body {
        margin: 0;
        overflow: hidden;
    }

    .google-visualization-tooltip {
        display: none;
    }

    .google-visualization-tooltip-portal {
        position: absolute;
        background-color: ${getColor('white')};
        z-index: 999;
    }

    .google-visualization-tooltip, .google-visualization-tooltip-portal {
        border-radius: 8px !important;
        box-shadow: ${getShadow('tooltip')} !important;
        border: none !important;
        padding: 5px !important;
        height: auto !important;
        pointer-events: none;

        & p {
            margin: 5px 0;
            font-size: 11px;
        }
    }

    .hide-rects rect {
        fill: transparent !important;
    }

    [role="button"]:focus {
        outline: none !important;
    }
`;

export const ThemeProvider = ({ children }) => (
    <BaseThemeProvider theme={theme}>
        <GlobalStyles />
        {children}
    </BaseThemeProvider>
);